// Horizontal monthly-budget bar: projected spend vs cap, with tick marks at
// 50 / 80 / 100% and a fill colored by projected band (green <80, amber <100,
// red ≥100). This replaces the old semicircular gauge to match the mockup's
// "Monthly budget" bar. The actual primitive lives in ui.tsx (BudgetBar) so it
// shares the project's tick-bar styling and dark variants.
import { BudgetBar } from "./ui";

interface Props {
  /** Projected fraction of cap (0.8 = 80%). May exceed 1. */
  fraction: number;
  capUsd: number;
  projectedUsd: number;
}

export function BudgetGauge({ fraction, capUsd, projectedUsd }: Props) {
  return <BudgetBar fraction={fraction} capUsd={capUsd} projectedUsd={projectedUsd} />;
}
